import { DEPARTMENT_OVERVIEW_REQUEST } from '../../actions/constants'; 

const initialState = {
  department_overview : null 
}

const departmentOverview = (state = initialState , action) => {
  switch (action.type) {
    case DEPARTMENT_OVERVIEW_REQUEST : {
      const newState = Object.assign({},state,{
        department_overview : action.payload
      })
      return newState;
    }
    default:
      return state;
  }
};
  
export default departmentOverview;
  